import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type ArtistPostProfileWorkHistoryStatusRequest = {
  profileId: string;
  workHistory: {
    hasWorkingExperience: boolean;
  };
};

export type ArtistPostProfileWorkHistoryStatusParams =
  RequestConfig<ArtistPostProfileWorkHistoryStatusRequest>;

export const artistPostProfileWorkHistoryStatus = async ({
  params,
  config
}: ArtistPostProfileWorkHistoryStatusParams) =>
  api.post(
    `/api/ArtistProfile/${params.profileId}/has-working-experience`,
    params.workHistory,
    config
  );
